import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

export interface ExamListTemplateProps {
  readonly headerActions: ReactNode;
  readonly filterPanel: ReactNode;
  readonly table: ReactNode;
}

export function ExamListTemplate({ headerActions, filterPanel, table }: ExamListTemplateProps) {
  const { t } = useTranslation('examManagement');

  return (
    <div className="flex flex-col gap-nano">
      {/** Breadcrumb */}
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{t('breadcrumb.exams')}</BreadcrumbPage>
      </Breadcrumb>

      {/** Header */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-nano">
          <h1 className="ts-heading-lg text-ctx-content-title">{t('title')}</h1>
          <p className="ts-paragraph-xs text-ctx-content-title">{t('subtitle')}</p>
        </div>
        {headerActions}
      </div>

      {/** Filters */}
      <div className="rounded-md border-hairline my-xxs border-ctx-layout-border bg-ctx-layout-surface p-sm shadow-level1">
        {filterPanel}
      </div>

      {/** Table */}
      <div className="overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1">
        {table}
      </div>
    </div>
  );
}
